function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  className: "canvas__node_icon_svgStock-shape",
  x: 2,
  y: 2,
  width: 56,
  height: 56,
  fill: "#FFFFFF",
  stroke: "#373A3C",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0713 36.501L20.5391 36.1104C20.7507 37.9007 21.2389 39.3737 22.0039 40.5293C22.7852 41.6686 23.9896 42.5964 25.6172 43.3125C27.2448 44.0124 29.0758 44.3623 31.1104 44.3623C32.917 44.3623 34.512 44.0938 35.8955 43.5566C37.279 43.0195 38.3044 42.2871 38.9717 41.3594C39.6553 40.4154 39.9971 39.39 39.9971 38.2832C39.9971 37.1602 39.6715 36.1836 39.0205 35.3535C38.3695 34.5072 37.2952 33.7992 35.7979 33.2295C34.8376 32.8551 32.7135 32.2773 29.4258 31.4961C26.138 30.6986 23.835 29.9499 22.5166 29.25C20.8076 28.3548 19.5299 27.248 18.6836 25.9297C17.8535 24.5951 17.4385 23.1058 17.4385 21.4619C17.4385 19.6553 17.9512 17.9707 18.9766 16.4082C20.002 14.8294 21.4993 13.6331 23.4688 12.8193C25.4382 12.0055 27.6273 11.5986 30.0361 11.5986C32.6891 11.5986 35.0247 12.0299 37.043 12.8926C39.0775 13.7389 40.64 14.9922 41.7305 16.6523C42.821 18.3125 43.4069 20.1924 43.4883 22.292L38.9473 22.6338C38.7031 20.3714 37.873 18.6624 36.457 17.5068C35.0573 16.3512 32.9821 15.7734 30.2314 15.7734C27.3669 15.7734 25.2754 16.3024 23.957 17.3604C22.6549 18.402 22.0039 19.6634 22.0039 21.1445C22.0039 22.4303 22.4678 23.4883 23.3955 24.3184C24.307 25.1484 26.6833 26.0029 30.5244 26.8818C34.3818 27.7445 37.0267 28.5013 38.459 29.1523C40.5423 30.1126 42.0804 31.3333 43.0732 32.8145C44.0661 34.2793 44.5625 35.972 44.5625 37.8926C44.5625 39.7969 44.0173 41.5954 42.9268 43.2881C41.8363 44.9645 40.2656 46.2747 38.2148 47.2188C36.1803 48.1465 33.8854 48.6104 31.3301 48.6104C28.0911 48.6104 25.373 48.1383 23.1758 47.1943C20.9948 46.2503 19.2777 44.8343 18.0244 42.9463C16.7874 41.042 16.1364 38.8936 16.0713 36.501Z",
  fill: "#373A3C"
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  className: "node_anchor_line",
  x1: -1,
  y1: 7,
  x2: 61,
  y2: 7
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  className: "node_anchor_line",
  x1: -1,
  y1: 7,
  x2: -1,
  y2: 65
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  className: "node_anchor_line",
  x1: 61,
  y1: 7,
  x2: 61,
  y2: 65
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  className: "node_center",
  cx: 30,
  cy: 38,
  r: 2
});

var SvgStock = function SvgStock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 58,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stock.c7e8c427.svg";
export { ForwardRef as ReactComponent };